import RecoverStep from "../recover_step";
import {attachContactSupportHandler, attachRowHandler} from "../../utils/recover_utils";

const TEMPLATE = 'drives';

export default class SetDrive extends RecoverStep {

    constructor() {
        super(TEMPLATE);
    }

    open(data, el, fr, previousStep) {
        data.render.searchComplete = true;
        data.drives = data.devices[data.recovery.device_id].jobs[data.recovery.job_id].drives;
        if (!data.tmp.last_backup) {
            const device = data.devices[data.recovery.device_id];
            if ((data.restore && data.restore.type && (data.restore.type === "cloud"))) {
                data.tmp.last_backup = { time: device.info['offsite_history_ls_cloud_rp'], str: device.info['offsite_history_ls_end_time_str'] };
            } else {
                data.tmp.last_backup = { time: device.info['onsite_history_ls_local_rp'], str: device.info['onsite_history_ls_end_time_str'] };
            }
        }
    }

    postRender(data, el, fr) {
        const $el = $(el);
        if (data.render.searchComplete) {
            attachRowHandler(el);
            attachContactSupportHandler(data, el, fr);
            alignHeaderOnLimitedHeightTable($el);
            $el.find('thead th:eq(1)').click();
        }
        $el.find('tbody tr').on('click', function() {
            const selected_row = $(this);
            if (!selected_row.length) { return; }
            data.tmp.previousStep = fr.currentStep;
            data.recovery.drive = selected_row.find('input').val();
            fr.goTo('setRecoveryPoint');
        })
    }

    transitionBack(data, el, fr) {
        data.tmp.last_backup = null;
        data.recovery.device_id = null;

        if (Object.keys(data.jobs).length > 1) {
            fr.goTo("setJob");
        } else if (data.deviceId) {
            fr.goTo("restoreType");
        } else {
            fr.goTo("setDevice");
        }
    }

}
